import {OtherSensorModel} from "../other-sensor.model";
import {PressureSensorModel} from "../perssure-sensor-model";
import {PfcSensorModel} from "../pfc-sensor.model";

export class SensorsOtherModel {
  otherSensors: OtherSensorModel[];
  pressureSensors: PressureSensorModel[];
  pfcSensors: PfcSensorModel[];

  constructor() {
    this.otherSensors = [];
    this.pressureSensors = [];
    this.pfcSensors = [];
  }

  public static initialize(model: SensorsOtherModel): void {
    if (!model.otherSensors) {
      model.otherSensors = [];
    }
    if (!model.pressureSensors) {
      model.pressureSensors = [];
    }
    if (!model.pfcSensors) {
      model.pfcSensors = [];
    }
  }
}

